import React, { PropsWithChildren } from 'react';
import { useTrans } from '@/custom-hooks/useTrans';
import { getAssetUrl } from '@/utils/utils';

import A11yImage from '@components/atoms/a11y-image/a11y-image';
import SwitchLink from '@components/menus/menu/switch-link/switch-link';

const PsbLogo = getAssetUrl('/images/psb_logo.png');

export default function PsbComponent({ children }: PropsWithChildren<{}>) {
    const { t } = useTrans();
    return (
        <SwitchLink
            akTestId='PSB|WWW.BEIAN.GOV.CN'
            to='http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402009871'
        >
            <A11yImage src={PsbLogo} altText={t('doNotTranslate:footer-zh.beianAltText')} />
            {children}
        </SwitchLink>
    );
}
